import { render, staticRenderFns } from "./InvalidApply.vue?vue&type=template&id=51be1252"
import script from "./InvalidApply.vue?vue&type=script&lang=ts"
export * from "./InvalidApply.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports